/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue18 } from '../../../../Fct/generics/FctParams';
import { FaEthereum } from 'react-icons/fa';
import { LIDO_STETH_TOKEN } from '../constants';
export var GetSharesByPooledETH = createPlugin({
    protocol: 'LIDO',
    type: 'GETTER',
    method: 'getSharesByPooledEth',
    supportedContracts: LIDO_STETH_TOKEN,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                ethAmount: new FctValue18({ isPreview: true, icon: FaEthereum }),
            },
        },
        output: {
            shares: new FctValue18({ isPreview: true }),
        },
    }); },
});
